import { Component, inject, OnInit } from '@angular/core';
import { UserDetails, UserRoles } from '../login/user.model';
import { Store } from '@ngrx/store';
import { UserState } from 'src/app/store/user/user.reducer';
import { Observable, map } from 'rxjs';
import {
  MatBottomSheet,
  MatBottomSheetModule,
} from '@angular/material/bottom-sheet';
import { ContactUsSheetComponent } from './contact-us-sheet/contact-us-sheet.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { RouterModule } from '@angular/router';
import { DefaultCommodityAutocompleteComponent } from './default-commodity-autocomplete/default-commodity-autocomplete.component';
import { MatRippleModule } from '@angular/material/core';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationPreferencesComponent } from './notification-preferences/notification-preferences.component';
import { environment } from 'src/environments/environment';
import { SeoService } from 'src/app/services/seo.service';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { selectUser } from 'src/app/store/user/user.selectors';

@Component({
  selector: 'app-my-profile',
  imports: [
    FormsModule,
    CommonModule,
    MatInputModule,
    MatCardModule,
    MatChipsModule,
    MatBottomSheetModule,
    MatRippleModule,
    RouterModule,
    DefaultCommodityAutocompleteComponent,
    NotificationPreferencesComponent,
  ],
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css'],
})
export class MyProfileComponent implements OnInit {
  private analytics = inject(Analytics);
  userRoles = UserRoles;
  links = environment.links;
  isLoading: boolean;
  userData$: Observable<UserDetails>;
  constructor(
    private store: Store<{ user: UserState }>,
    private _bottomSheet: MatBottomSheet,
    private authService: AuthService,
    private seoService: SeoService
  ) {}

  ngOnInit(): void {
    logEvent(this.analytics, 'settings_view');

    this.seoService.updateMetaTags([
      {
        name: 'description',
        content: 'My Profile Page. Set user preferences and push notifications',
      },
      { name: 'author', content: "Johnston's Connected" },
      { name: 'keywords', content: 'My Profile, Settings' },
    ]);
    this.seoService.updateTitle('Profile Page');

    this.isLoading = false;
    this.userData$ = this.store.select(selectUser).pipe(
      map((user) => {
        this.isLoading = false;
        return user;
      })
    );
  }

  openContactUsForm() {
    this._bottomSheet.open(ContactUsSheetComponent, {
      panelClass: ['bottomsheet-bg'],
    });
  }

  logout(): void {
    logEvent(this.analytics, 'settings_tap_sign_out');
    this.authService.logout();
  }
}
